import { CLICK_PORTAL_CARD_LAYOUT } from 'consts';

/**
 * Site card layout, replaced by the section card when the section has one.
 */
export function resolveClickPortalResultCardLayout(
  sectionLayout: string | undefined,
  siteLayout: CLICK_PORTAL_CARD_LAYOUT
): CLICK_PORTAL_CARD_LAYOUT {
  if (
    sectionLayout === CLICK_PORTAL_CARD_LAYOUT.RESULT_CARD ||
    sectionLayout === CLICK_PORTAL_CARD_LAYOUT.PORTAL_CARD ||
    sectionLayout === CLICK_PORTAL_CARD_LAYOUT.GRID_CARD
  ) {
    return sectionLayout;
  }

  return siteLayout;
}
